import React from 'react'
import ReactDOMServer from 'react-dom/server'
import { Col, Card, CardBody, Row, Button, } from 'reactstrap'
import { AssessDashCircle, AssessDashStartOrResume, AssessDashSubtestResults, AssessSelectorNav } from '../Assessment'
import { Link } from 'react-router-dom'
import AssessPrintTemplate from './AssessPrint/AssessPrintTemplate'
import forOwn from 'mout/object/forOwn'
import has from 'mout/object/has'
import values from 'mout/object/values'
import PDFreactor from '../../helpers/pdfreactor/PDFreactor'
import sortByPropText from '../../helpers/content/manageSets/sortByPropText'
import getFirstSubtestId from '../../helpers/nav/getFirstSubtestId'
import { BeatLoader, SyncLoader} from 'react-spinners'

/* Top:
  <AssessDashTestSummary
    sm='12'
    md='12'
    lg='12'
    xl='12'
    sub={false}
    title={topTitle}
    subtest={firstIncompleteSubtest}
    resume={topResume}
    userAssessmentId={sumData.userAssessmentId ? sumData.userAssessmentId : ''}
    groupUAId ={sumData.groupUAId ? sumData.groupUAId : ''}
    scoring={sumData.scoring}
    subtests={sumData.subtests}
    topComplete={topComplete}
    assessmentId={this.props.assessmentId}
    selectedGroupUA={this.props.selectedGroupUA}
    selectedStudent={this.props.selectedStudent}
    isStudent={this.props.user.role === 'Student'}
    needAlert={needAlert}
    groupUA={props.groupUA}
    userAssessment={props.userAssessment}
  />

  SubTests:
    <AssessDashTestSummary
      sm='12'
      md='12'
      lg='6'
      xl='6'
      sub={true}
      title={subtest.displayName}
      key={`subTestSummary${subtest.setId}`}
      subtest={subtest}
      resume={resume}
      userAssessmentId={this.props.userAssessment ? this.props.userAssessment.userAssessmentId : ''}
      complete={complete}
      scoring={this.props.userAssessment ? this.props.userAssessment.scoring : null}
      nodes={this.props.nodes}
      isStudent={this.props.user.role === 'Student'}
    />

  GroupUA Subtests:
    <AssessDashTestSummary
      sm='12'
      md='12'
      lg='6'
      xl='6'
      sub={true}
      title={subtest.displayName}
      key={`subTestSummary${subtest.setId}`}
      subtest={subtest}
      resume={false}
      groupUAId={this.props.selectedGroupUA}
      complete={true}
      scoring={scoring}
      nodes={this.props.nodes}
      isStudent={false}
    />

*/

export default function AssessDashTestSummary(props) {
  const { notInitializing } = props

  let labels = ['English', 'Math', 'Reading', 'Science', '']
  let data = [1, 1, 1, 1, 0]
  let backgroundColor = ['#4d4d4d', '#4d4d4d', '#4d4d4d', '#4d4d4d', '#4d4d4d']
  let hoverBackgroundColor = backgroundColor

  if (!props.sub && props.subtests && props.scoring) {

    let scores = {
      English: 0,
      Math: 0,
      Reading: 0,
      Science: 0,
      nil: 144,
    }
    if (props.scoring) {
      forOwn(props.scoring.bySubtest, (val, key, o) => {
        if (val.complete) {
          const thisScale = val.scale
          const thisSubject = props.subtests[key].displayName
          scores[thisSubject] = thisScale
          scores.nil -= thisScale
        }
      })
    }
    if (scores.nil < 144) {
      data = [
        scores.English,
        scores.Math,
        scores.Reading,
        scores.Science,
        scores.nil,
      ]
      backgroundColor = ['purple', '#f86c6b', '#20a8d8', '#4dbd74', '#4d4d4d',]
      hoverBackgroundColor = backgroundColor
    }
  }

  let link = '/assessment/print/'
  if (((!props.selectedGroupUA && !props.selectedStudent) || props.selectedStudent) && props.userAssessmentId) {
    link = `/assessment/print/${props.userAssessmentId}`
  } else if (props.selectedGroupUA) {
    const year = props.year
    link = `/assessment/print/${props.groupUAId}?g=true&a=${props.assessmentId}&y=${year}`
  }
  let printButton = (
    <Link
      to={link}
      //target='_blank'
      className={'m2no-decoration m2whitelink'}
    >
      <Button
        color='secondary'
      >
        Print
      </Button>
    </Link>
  )
  props.sub || props.needAlert ? printButton = null : null

  let subCirclesRow = null
  let subCircles = []
  if (!props.sub) {
    const colorsBySubtestType = {
      English: 'purple',
      Math: '#f86c6b',
      Reading: '#20a8d8',
      Science: '#4dbd74',
    }
    const fallbackColor = '#ffc107'
    const themeColors = {
      English: 'english',
      Math: 'danger',
      Reading: 'primary',
      Science: 'success',
    }
    let sortedSubtests = []
    const fallbackThemeColor = 'warning'
    if (props.subtests) {
      const subs = sortByPropText(values(props.subtests), 'index')
      let scoringCompare = props.scoringCompare
      subs.forEach((subtest) => {
        const labels = [subtest.displayName, 'Missed']
        let data = [1, 1]
        let backgroundColorSub = ['#4d4d4d', '#4d4d4d']
        let hoverBackgroundColorSub = backgroundColorSub
        let score, scaleDisplay , scoreCompare , scaleDisplayCompare
        if (props.scoring.bySubtest) {
          score = props.scoring.bySubtest[subtest.setId]
          if (score) {
            if (props.isStudent || props.selectedStudent) {
              data = [parseInt(score.scale), parseInt(36 - score.scale)]
            } else {
              scaleDisplay = (Math.round(parseFloat(score.scale) * 10) / 10).toFixed(1)
              data = [scaleDisplay, 36 - scaleDisplay]
            }
            if (colorsBySubtestType[subtest.displayName]) {
              backgroundColorSub = [
                colorsBySubtestType[subtest.displayName],
                '#4d4d4d',
              ]
            } else {
              backgroundColorSub = [fallbackColor, '#4d4d4d']
            }
            hoverBackgroundColorSub = backgroundColorSub
          }
          if (!scaleDisplay && score) {
            scaleDisplay = parseInt(score.scale, 10)
          }
        }   

        if (scoringCompare && props.scoringCompare.bySubtest) {
          scoreCompare = props.scoringCompare.bySubtest[subtest.setId]
          if (scoreCompare) {
            if (props.isStudent || props.selectedStudent) {
              data = [parseInt(scoreCompare.scale), parseInt(36 - scoreCompare.scale)]
            } else {
              scaleDisplayCompare = (Math.round(parseFloat(scoreCompare.scale) * 10) / 10).toFixed(1)
              data = [scaleDisplayCompare, 36 - scaleDisplayCompare]
            }
            if (colorsBySubtestType[subtest.displayName]) {
              backgroundColorSub = [
                colorsBySubtestType[subtest.displayName],
                '#4d4d4d',
              ]
            } else {
              backgroundColorSub = [fallbackColor, '#4d4d4d']
            }
            hoverBackgroundColorSub = backgroundColorSub
          }
          if (!scaleDisplayCompare && scoreCompare) {
            if(typeof scoreCompare === undefined ){
              scaleDisplayCompare = 0 
            }
            else{

              scaleDisplayCompare = parseInt(scoreCompare.scale, 10)
            }
          }
        } 
        // if(typeof scaleDisplayCompare === undefined){
        //   scaleDisplayCompare = 0
        // }


        {/* 4 Section Donuts in Top Card */ }
        subCircles.push(
          <Col 
          xs='6' 
          md='3' 
          lg='6' 
          xl='3' 
          key={`circle${subtest.setId}`}>
            <AssessDashCircle
              labels={labels}
              data={data}
              backgroundColor={backgroundColorSub}
              hoverBackgroundColor={hoverBackgroundColorSub}
              subject={subtest.displayName}
              score={scaleDisplay ? scaleDisplay : 0}
              compareScore={scaleDisplayCompare ? scaleDisplayCompare : 0}
              top={true} 
              clicked = {()=>{}}
              isCompare = {props.isCompare}
              test1 = {props.test1}
              test2 = {props.test2}
              isSwap = {props.isSwap}
            />
          </Col>
        )
      })
      subCirclesRow = (
        <Row>
          {subCircles}
        </Row>
      )
    }



  }

  let compositeScore = 0
  if (has(props, 'scoring.byTest.scale')) {
    if (props.isStudent || props.selectedStudent) {
      compositeScore = parseInt(props.scoring.byTest.scale)
    } else {
      compositeScore = Math.round(parseFloat(props.scoring.byTest.scale) * 10) / 10
    }
  }

  let compositeScoreCompare = 0
  if (has(props, 'scoring.byTest.scale')) {
    if (props.isStudent || props.selectedStudent) {
      compositeScoreCompare = (props.scoringCompare && props.scoringCompare.byTest !== null) ? props.scoringCompare && parseInt(props.scoringCompare.byTest.scale) : 0
    } else {
      compositeScoreCompare = props.scoringCompare && (props.scoringCompare.byTest !== null) ?  Math.round(parseFloat(props.scoringCompare.byTest.scale) * 10) / 10 : 0
    }
  }

  let selectorNav = null
  if (!props.sub) {
    // create the overview link
    let overviewQuery = ''
    if (props.selectedGroupUA && !props.isStudent) {
      overviewQuery = `?gua=${props.selectedGroupUA}`
    }
    if (props.selectedGroupUA && props.selectedStudent) {
      overviewQuery = `?gua=${props.selectedGroupUA}&s=${props.selectedStudent}`
    }

    // find the index 0 subtest to create the links
    let uA, firstSubtestId
    let skillReportLink = ''
    let itemReportLink = ''
    if (props.user.role === 'Student' && props.userAssessment) {
      firstSubtestId = getFirstSubtestId(props.userAssessment)
      if (props.activeSubtest) {
        firstSubtestId = props.activeSubtest
      }
      skillReportLink = `/assessment/reports/${props.userAssessment.userAssessmentId}/${firstSubtestId}`
      itemReportLink = `/assessment/testing/${props.userAssessment.userAssessmentId}/${firstSubtestId}?item=overview`
    } else if (props.selectedStudent) {
      firstSubtestId = getFirstSubtestId(props.groupUA)
      if (props.activeSubtest) {
        firstSubtestId = props.activeSubtest
      }
      let studentQuery = ''
      if (props.selectedStudent) {
        studentQuery = `&s=${props.selectedStudent}`
      }
      skillReportLink = `/assessment/reports/${props.selectedGroupUA}/${firstSubtestId}/?g=true&a=${props.assessmentId}${studentQuery}`
      itemReportLink = `/assessment/testing/${props.selectedGroupUA}/${firstSubtestId}?item=overview&g=true&a=${props.assessmentId}${studentQuery}`
      itemReportLink = `/assessment/testing/${props.selectedGroupUA}/${firstSubtestId}?item=overview&g=true&a=${props.assessmentId}${studentQuery}`
    } else if (props.groupUA) {
      firstSubtestId = getFirstSubtestId(props.groupUA)
      if (props.activeSubtest) {
        firstSubtestId = props.activeSubtest
      }
      let studentQuery = ''
      if (props.selectedStudent) {
        studentQuery = `&s=${props.selectedStudent}`
      }
      skillReportLink = `/assessment/reports/${props.selectedGroupUA}/${firstSubtestId}/?g=true&a=${props.assessmentId}${studentQuery}`
      itemReportLink = `/assessment/testing/${props.selectedGroupUA}/${firstSubtestId}?item=overview&g=true&a=${props.assessmentId}${studentQuery}`
    }


    selectorNav = (
      <AssessSelectorNav
        overviewLink={`/assessment/dashboard/${props.assessmentId}${overviewQuery}`}
        skillReportLink={skillReportLink}
        itemReportLink={itemReportLink}
      />
    )
  }


  const startCard = (
    // Sub card when test isn't completed
    <Card className='start-card assessment-overview-by-subject rounded-top'>
      <Row className='assessment-overview-by-subject__title-container rounded-top' noGutters>
        <Col xs='12'>
          {props.sub ? <h3 className='title'>{props.title}</h3> : null}
          {props.sub ? null : subCirclesRow}
        </Col>
      </Row>
      <CardBody>
        <Row>
          <Col xs='12'>
            {/* Add gray donut chart here
            <div className="donut-chart not-completed">
              <ul className='assessment-score'>
                <li className='section-score'>0cat</li>
              </ul>
            </div>
            */}
            <AssessDashCircle
              score={0}
              subject={props.subtest ? props.subtest.displayName : ''}
            />
          </Col>
          <Col xs='12' sm='12' md='6' lg='8' xl='9'>
            {printButton}
          </Col>
        </Row>
        {selectorNav}
        <AssessDashStartOrResume
          subtest={props.subtest}
          resume={props.resume}
          userAssessmentId={props.userAssessmentId}
          groupUAId={props.groupUAId}
          sub={props.sub}
          topComplete={props.topComplete}
          isStudent={props.isStudent}
          selectedStudent = {props.selectedStudent}
          groupUA={props.groupUA}
          userAssessment={props.userAssessment}
          licenseExpired={props.licenseExpired}
        />
      </CardBody>
    </Card>
  )
  const topCard = (
    <Card className='top-card'>
      <CardBody>
        <Row>
          <Col xs='12' lg='4' className='test-progress'>
            {(props.groupUAId || props.groupUAIdCompare) || (props.userAssessmentId && props.userAssessment)
              ? <AssessDashStartOrResume
                subtest={props.subtest}
                resume={props.resume || props.topResume}
                userAssessmentId={props.userAssessmentId}
                groupUAId={props.groupUAId}
                groupUAIdCompare={props.groupUAIdCompare}
                sub={props.sub}
                topComplete={props.topComplete}
                isStudent={props.isStudent}
                selectedStudent = {props.selectedStudent}
                groupUA={props.groupUA}
                userAssessment={props.userAssessment}
                printPath={props.printPath}
                licenseExpired={props.licenseExpired}
              />
              :
              <div className='loading-animation' style={{height: '180px'}}>
                <BeatLoader loading={!notInitializing} color={"#00C1AB"} />
              </div>
            }
          </Col>
          {/* Composite Donut in Top Card */}
          <Col className='top-card-donut-chart-container' xs='12' lg='8' xl='8'>
            <Row>
              <Col xs='12' sm='5' md='4' lg='5' xl='3' className="composite-donut">
                {props.subtests &&
                  <AssessDashCircle
                    labels={labels}
                    data={data}
                    backgroundColor={backgroundColor}
                    hoverBackgroundColor={hoverBackgroundColor}
                    score={compositeScore ? compositeScore : 0}
                    subject={'Composite'}
                    top={true}
                    compareScore = {Number(compositeScoreCompare) ? Number(compositeScoreCompare) : 0}
                    isCompare = {props.isCompare}
                    test1 = {props.test1}
                    test2 = {props.test2}
                    isSwap = {props.isSwap}
                  />
                }
                <div className='loading-animation'>
                <BeatLoader loading={!props.subtests && !notInitializing} color={"#00C1AB"} />
                </div>
              </Col>
              <Col xs='12' sm='7' md='8' lg='7' xl='9' className="subject-donuts">
                {props.subtests && subCirclesRow}

                <div className='loading-animation'>
                  <BeatLoader loading={!props.subtests && !notInitializing} color={"#00C1AB"} />
                </div>

              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
      {selectorNav}
    </Card>
  )

  let byNodeScoring = null
  let bySubtestScoring = null
  if (props.scoring && props.subtest) {
    byNodeScoring = props.scoring.byNode[props.subtest.setId]
    bySubtestScoring = props.scoring.bySubtest[props.subtest.setId]
  }

  const completeCard = (
    <AssessDashSubtestResults
      sub={props.sub}
      title={props.title}
      subtest={props.subtest}
      byNodeScoring={byNodeScoring}
      bySubtestScoring={bySubtestScoring}
      nodes={props.nodes}
      userAssessmentId={props.userAssessmentId}
      groupUAId={props.groupUAId}
      isStudent={props.isStudent}
      assessmentId={props.assessmentId}
      selectedGroupUA={props.selectedGroupUA}
      selectedStudent={props.selectedStudent}
      user={props.user}
      groupUA={props.groupUA}
      userAssessment={props.userAssessment}
    />
  )

  let theCard = startCard
  if (props.sub && props.complete) {
    theCard = completeCard
  } else if (!props.sub) {
    theCard = topCard
  }

  return (
    <Col
      xs={props.xs ? props.xs : '12'}
      sm={props.sm ? props.sm : '12'}
      md={props.md ? props.md : '12'}
      lg={props.lg ? props.lg : '6'}
      xl={props.xl ? props.xl : '6'}
    >
      {theCard}
    </Col>
  )
}



/*
  const data = {
    labels: props.labels,
    datasets: {
      data: props.data,
      backgroundColor: props.backgroundColor,
      hoverBackgroundColor: props.hoverBackgroundColor,
    }
  }


*/


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessDashTestSummary.js